import { FilterOption } from '@plugins/shared/types/post/filter';
import { SortType } from '@plugins/shared/types/sort';

export const DEFAULT_FILTER_OPTIONS: FilterOption<string>[] = [
  { display: 'all', value: 'all', static: true },
  { display: 'own', value: 'own', static: true },
  { display: 'subscriptions', value: 'subscriptions', static: true },
];

export const DEFAULT_SORT_OPTIONS: FilterOption<SortType>[] = [
  { display: 'newOld', value: SortType.NEW_OLD, static: true },
  { display: 'oldNew', value: SortType.OLD_NEW, static: true },
  { display: 'popular', value: SortType.POPULAR, static: true },
  { display: 'unpopular', value: SortType.UNPOPULAR, static: true },
  { display: 'repliesDesc', value: SortType.REPLIES_DESC, static: true },
  { display: 'repliesAsc', value: SortType.REPLIES_ASC, static: true },
  { display: 'az', value: SortType.AZ, static: true },
  { display: 'za', value: SortType.ZA, static: true },
];

export const SORT_ICONS: Record<SortType, string> = {
  [SortType.NEW_OLD]: 'pi-sort-amount-down-alt',
  [SortType.OLD_NEW]: 'pi-sort-amount-down',
  [SortType.POPULAR]: 'pi-thumbs-up',
  [SortType.UNPOPULAR]: 'pi-thumbs-down',
  [SortType.REPLIES_DESC]: 'pi-comments',
  [SortType.REPLIES_ASC]: 'pi-comment',
  [SortType.AZ]: 'pi-sort-alpha-down',
  [SortType.ZA]: 'pi-sort-alpha-down-alt',
};
